import { useState } from "react";
import {
    AppBar,
    Toolbar,
    Box,
    Button,
    IconButton,
    Drawer,
    Stack,
    Container,
    Divider
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from '@mui/icons-material/Close';
import LanguageIcon from "@mui/icons-material/Language";
import { Link as RouterLink } from "react-router-dom";

import Logo from "../assets/logouaithaiPreta.png";

export default function Header() {
    const [open, setOpen] = useState(false);

    const toggleDrawer = (value) => () => setOpen(value);

    const NavLinks = ({ mobile = false, onClick }) => (
        <Stack
            direction={mobile ? "column" : "row"}
            spacing={mobile ? 2.5 : 4}
            alignItems={mobile ? "flex-start" : "center"}
        >

            {mobile && (
                <Button
                    component={RouterLink}
                    to="/"
                    onClick={onClick}
                    sx={{ color: "var(--cinza)" }}
                >
                    Início
                </Button>
            )}
            <Button component={RouterLink} to="/nossa-historia" onClick={onClick} sx={{ color: "var(--cinza)" }}>
                Nossa História
            </Button>

            <Button component={RouterLink} to="/casa" onClick={onClick} sx={{ color: "var(--cinza)" }}>
                Conheça a Casa
            </Button>

            <Button
              component="a"
              href="/imagens/cardapio.jpeg"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "var(--cinza)" }}
            >
              Menu
            </Button>

            <Button component={RouterLink} to="/contato" onClick={onClick} sx={{ color: "var(--cinza)" }}>
                Contato
            </Button>
        </Stack>
    );

    return (
        <>
            <AppBar
                position="sticky"
                elevation={0}
                sx={{
                    background: "rgba(250, 250, 248, 0.9)",
                    backdropFilter: "blur(10px)",
                    borderBottom: "1px solid rgba(0,0,0,0.06)",
                }}
            >
                <Container maxWidth="lg">
                    <Toolbar
                        disableGutters
                        sx={{
                            minHeight: 72,
                            display: "flex",
                            justifyContent: "space-between",
                        }}
                    >
                        {/* LOGO */}
                        <Box
                            component={RouterLink}
                            to="/"
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                textDecoration: "none",
                            }}
                        >
                            <Box component="img" src={Logo} alt="Uai Thai" sx={{ height: 48 }} />
                        </Box>

                        {/* NAV DESKTOP */}
                        <Box sx={{ display: { xs: "none", md: "flex" } }}>
                            <NavLinks />
                        </Box>

                        {/* AÇÕES DESKTOP */}
                        <Stack
                            direction="row"
                            spacing={1.5}
                            alignItems="center"
                            sx={{ display: { xs: "none", md: "flex" } }}
                        >
                            <Button
                                component={RouterLink}
                                to="/reservas"
                                variant="contained"
                                sx={{
                                    bgcolor: "var(--cinza)",
                                    fontWeight: 700,
                                    px: 2.5,
                                    "&:hover": { bgcolor: "var(--azulEscuro)" },
                                }}
                            >
                                Reservar Mesa
                            </Button>

                            {/* <IconButton
                                sx={{
                                    border: "1px solid var(--cinza)",
                                    color: "var(--cinza)",
                                }}
                            >
                                <LanguageIcon />
                            </IconButton> */}
                        </Stack>

                        {/* BOTÃO MOBILE */}
                        <IconButton
                            onClick={toggleDrawer(true)}
                            sx={{ display: { xs: "flex", md: "none", color: "var(--cinza)" } }}
                        >
                            <MenuIcon />
                        </IconButton>
                    </Toolbar>
                </Container>
            </AppBar>

            {/* DRAWER MOBILE */}
            <Drawer anchor="right" open={open} onClose={toggleDrawer(false)}>
                <Box
                    sx={{
                        width: "100vw",
                        height: "100%",
                        bgcolor: "var(--offwhite)",
                        p: 3,
                    }}
                >
                    <Stack spacing={3}>
                        {/* HEADER DO DRAWER */}
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                            }}
                        >
                            {/* BOTÃO FECHAR */}
                            <IconButton
                                onClick={toggleDrawer(false)}
                                sx={{ color: "var(--cinza)" }}
                            >
                                <CloseIcon />
                            </IconButton>

                            {/* LOGO */}
                            <Box
                                component="img"
                                src={Logo}
                                alt="Uai Thai"
                                sx={{ height: 42 }}
                            />
                        </Box>

                        <Divider />

                        {/* LINKS */}
                        <NavLinks mobile onClick={toggleDrawer(false)} />

                        {/* CTA */}
                        <Button
                            component={RouterLink}
                            to="/reservas"
                            variant="contained"
                            sx={{
                                bgcolor: "var(--azulEscuro)",
                                fontWeight: 800,
                                borderRadius: 2,
                                "&:hover": { bgcolor: "var(--vermelho)" },
                            }}
                            onClick={toggleDrawer(false)}
                        >
                            Reservar Mesa
                        </Button>
                    </Stack>
                </Box>
            </Drawer>
        </>
    );
}
